/* eslint-disable no-console -- logger doesn't work in this context */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "initAction", {
    enumerable: true,
    get: function() {
        return initAction;
    }
});
const _config = require("@lage-run/config");
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _execa = /*#__PURE__*/ _interop_require_default(require("execa"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function initAction() {
    const cwd = process.cwd();
    const config = await (0, _config.readConfigFile)(cwd);
    if (config) {
        console.error("lage is already initialized in this workspace");
        process.exitCode = 1;
        return;
    }
    console.info("Installing lage and creating a default configuration file");
    let workspaceManager = "yarn";
    try {
        workspaceManager = whichWorkspaceManager(cwd);
    } catch (e) {
        console.error("lage requires you to be using a workspace - make sure you are using yarn workspaces, npm workspaces, pnpm workspaces, or rush");
        process.exitCode = 1;
        return;
    }
    const pipeline = {
        build: [
            "^build"
        ],
        test: [
            "build"
        ],
        lint: []
    };
    const lageConfig = {
        pipeline,
        npmClient: workspaceManager === "yarn" ? "yarn" : "npm"
    };
    const lageConfigFile = _path.default.join(cwd, "lage.config.js");
    _fs.default.writeFileSync(lageConfigFile, "module.exports = " + JSON.stringify(lageConfig, null, 2) + ";");
    installLage(cwd, workspaceManager, pipeline);
    console.info(`Lage is initialized! You can now run: ${getBuildCommand(workspaceManager)}`);
}
function getBuildCommand(workspaceManager) {
    switch(workspaceManager){
        case "yarn":
            return "yarn lage build";
        case "pnpm":
            return "pnpm run lage build";
        case "rush":
        case "npm":
            return "npm run lage build";
    }
}
function whichWorkspaceManager(cwd) {
    const packageJson = readPackageJson(cwd);
    if (_fs.default.existsSync(_path.default.join(cwd, "rush.json"))) {
        return "rush";
    }
    if (_fs.default.existsSync(_path.default.join(cwd, "yarn.lock")) && packageJson.workspaces) {
        return "yarn";
    }
    if (_fs.default.existsSync(_path.default.join(cwd, "pnpm-workspace.yaml"))) {
        return "pnpm";
    }
    if (_fs.default.existsSync(_path.default.join(cwd, "package-lock.json")) && packageJson.workspaces) {
        return "npm";
    }
    throw new Error("not a workspace");
}
async function installLage(cwd, workspaceManager, pipeline) {
    var _packageJson;
    const lageVersion = getLageVersion();
    const packageJson = readPackageJson(cwd);
    (_packageJson = packageJson).scripts ?? (_packageJson.scripts = {});
    for (const script of Object.keys(pipeline)){
        packageJson.scripts[script] = `lage ${script}`;
    }
    if (workspaceManager === "rush") {
        packageJson.scripts.lage = `node common/scripts/install-run.js lage@${lageVersion} lage`;
        writePackageJson(cwd, packageJson);
    } else {
        var _packageJson1;
        packageJson.scripts.lage = "lage";
        (_packageJson1 = packageJson).devDependencies ?? (_packageJson1.devDependencies = {});
        packageJson.devDependencies.lage = lageVersion;
        writePackageJson(cwd, packageJson);
        await (0, _execa.default)(workspaceManager, [
            "install"
        ], {
            stdio: "inherit",
            shell: true
        });
    }
}
function getLageVersion() {
    const lagePackageJsonFile = require.resolve("../../package.json", {
        paths: [
            __dirname
        ]
    });
    const lagePackageJson = JSON.parse(_fs.default.readFileSync(lagePackageJsonFile, "utf-8"));
    return lagePackageJson.version;
}
function writePackageJson(cwd, packageJson) {
    const packageJsonFile = _path.default.join(cwd, "package.json");
    _fs.default.writeFileSync(packageJsonFile, JSON.stringify(packageJson, null, 2));
}
function readPackageJson(cwd) {
    const packageJsonFile = _path.default.join(cwd, "package.json");
    return JSON.parse(_fs.default.readFileSync(packageJsonFile, "utf-8"));
}
